import React, {Component} from 'react';
import { Row, Col, Icon, Spin, Button, message, Dropdown, Menu } from 'antd/lib/index';
import {loadAttachmentFiles, takeTask, changeTaskStatus} from '../../actions/interview';
import {connect} from "react-redux";
import {Scrollbars} from "react-custom-scrollbars";
import {ATTCHMENT_TYPE, PIC_TYPE} from "../../constants";
import ChunkUpload from "../upload/ChunkUpload";
import UploadWall from "../upload/UploadWall";
import {applicationName, getSubffix, permissionCheck, uuid} from "../../utils";


export const INTERVIEW_ROLE_TYPE_MAP = {
    type_1: "文字记者",
    type_2: "摄影记者",
    type_3: "摄像记者",
    type_4: "美工包装",
    type_5: "学生编辑负责人",
};

export const INTERVIEW_STATUS_TYPE_MAP = {
    type_1: "未领取",
    type_2: "已领取",
    type_3: "已提交",
    type_4: "已发布",
};

const ButtonGroup = Button.Group;

export class NewsActivityBaseInfoFooter extends Component{

    state = {
        lqBtnLoading:false,
        data: this.props.data
    };

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            data: nextProps.data
        })
    }

    changeActivStatus = (status) => {
       let params = { id: this.state.data.id, status };
       changeTaskStatus(params, (res)  => {
           console.log(this.props.getData)
           if(res.status === 200){
               //重新查询列表数据
               this.props.cencel && this.props.cencel();
               this.props.getData && this.props.getData();
           }
       })
    }

    render() {
        const menu = <Menu>
                         <Menu.Item onClick={() => this.changeActivStatus('3')}>已提交</Menu.Item>
                         <Menu.Item onClick={() => this.changeActivStatus('4')}>已完成</Menu.Item>
                     </Menu>
        let isShowLQBtn = false;
        let nowDate=new Date().getTime();//当前时间
        // data. status <3  任务在在3以前  并且没有超期
        let statusName;
        let row = this.state.data;
        let activityTime;//活动时间
        if(row.endDate){
            activityTime=row.endDate.time;
        }else{
            activityTime=row.interviewEndDate?row.interviewEndDate.time:0;//活动时间
        }
        if(this.state.data.status<4){

            let overdue=true;
            if(activityTime>0&&activityTime<nowDate){
                overdue=false;
            }
            if(this.state.data.status===1&&overdue){
                this.state.data.interviewJointers && this.state.data.interviewJointers.map(item=>{
                    if(item.account && this.props.currentUser && this.props.currentUser.account && (item.account === this.props.currentUser.account)){
                        isShowLQBtn = parseInt(item.status) === 1;//1是未领取
                    }
                });
            }else if(this.props.data.status!==1){
                this.state.data.interviewJointers && this.state.data.interviewJointers.map(item=>{
                    if(item.account && this.props.currentUser && this.props.currentUser.account && (item.account === this.props.currentUser.account)){
                        isShowLQBtn = parseInt(item.status) === 1;//1是未领取
                    }
                });
            }
        }
        let isOpAuth = permissionCheck("pms:newsActiviti:edit");
        let isEditAuth = (this.state.data.status !== 4);//已发布


        if(this.state.data.status===1&&activityTime&&activityTime<nowDate){
            statusName='已超期'
        }
        isEditAuth = (isOpAuth&&isEditAuth&&(statusName!=='已超期'));
        return <div style={{textAlign:"center"}}>
            {isShowLQBtn?<Button type={"primary"} style={{marginRight:"10px"}} onClick={()=>{
                this.setState({
                    lqBtnLoading:true
                });
                takeTask(this.state.data.id).then(()=>{
                    message.success("领取成功");
                    this.setState(prevState=>{
                        prevState.data.interviewJointers && prevState.data.interviewJointers.map(item=>{
                            if(item.account && this.props.currentUser && this.props.currentUser.account && (item.account === this.props.currentUser.account)){
                                item.status = 2;//2是领取
                            }
                        });
                        return {
                            lqBtnLoading:false,
                            data : prevState.data
                        }
                    });
                    this.props.takeTaskAfter();
                },()=>{
                    message.error("领取失败");
                });
            }}>领取任务</Button>:""}
            {this.props.showEditBtn&&isEditAuth?<Button onClick={()=>this.props.update(this.state.data.id)} style={{marginRight:"10px"}}>修改</Button>:""}
            <Button onClick={()=>this.props.cencel()} >取消</Button>
            {
             permissionCheck("pms:newsActiviti:editStatus") ? (this.state.data.status>1&&statusName!=='已超期'?<Dropdown overlay={menu} placement="bottomLeft">
                     <ButtonGroup style={{ marginLeft: 20}}>
                         <Button type="primary">修改状态</Button>
                         <Button type="primary" icon="ellipsis"></Button>
                     </ButtonGroup>

                 </Dropdown> :null)

           :  null
            }
    </div>

    }
}
NewsActivityBaseInfoFooter.defaultProps = {
    data:{},
    account:"",
    cencel:()=>{},
    update:()=>{},
    takeTaskAfter:()=>{},
    showEditBtn:true,//原来使用的都显示修改，此功能针对桌面不显示修改按钮，给false
};

export const getRoleNames = (interviewJointers, currentUserAccount, map)=>{
    let roleNames = [];
    interviewJointers && interviewJointers.map(jointer=>{
        if(jointer.account === currentUserAccount){
            if(map["type_"+jointer.interviewRole]){
                roleNames.push(map["type_"+jointer.interviewRole])
            }
        }
    });
    return roleNames.join("、")
};

class NewsActivityBaseInfo extends Component {

    constructor(props){
        super(props);
        this.state = {
            loadAttachmentFiles:false,//是否已经加载了附件
            files:[]
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            loadAttachmentFiles:false,
        });
        loadAttachmentFiles(nextProps.data.attachmentResourceIds, (res)=>{
            this.setState({
                loadAttachmentFiles:true,
                files: res
            })
        });
    }

    componentWillMount() {
        this.initAttachmentFiles();
    }

    initAttachmentFiles = ()=>{
        loadAttachmentFiles(this.props.data.attachmentResourceIds, (res)=>{
            this.setState({
                loadAttachmentFiles:true,
                files: res
            })
        });
    };

    formatEventItem = (eventItem)=>{
        let res = [];
        eventItem && eventItem.reverse().map(item=>{
            res.push(item.name);
        });
        return res.join("、");
    };

    showRoles = (interviewJointers)=>{
        let roleNames = [];
        if(this.props.currentUser && this.props.currentUser.account){
            return getRoleNames(interviewJointers, this.props.currentUser.account, INTERVIEW_ROLE_TYPE_MAP);
        }
        return roleNames.join("、")
    };

    render() {
        return (
            <div style={{backgroundColor:"#f4f6fc",padding:"20px",width:"100%"}}>
                <Scrollbars
                    autoHeight
                    autoHeightMax={600}
                >
                    <div style={{width:"99%", backgroundColor:"#fff", padding:"32px 40px"}}>
                        <Row gutter={40}>
                            <Col span={8}><TextInfo title={"任务名称"} desc={this.props.data.title}/></Col>
                            <Col span={8}><TextInfo title={"所属项目"} desc={this.formatEventItem(this.props.data.eventItem)}/></Col>
                            <Col span={8}><TextInfo title={"活动时间"} desc={window.formatDate(this.props.data.interviewDate)}/></Col>
                        </Row>
                        <Row gutter={40} style={{marginTop:"16px"}}>
                            <Col span={8}><TextInfo title={"活动地点"} desc={this.props.data.place}/></Col>
                            <Col span={8}><TextInfo title={"回稿时间"} desc={window.formatDate(this.props.data.endDate)}/></Col>
                            <Col span={8}><TextInfo title={"主办单位"} desc={this.props.data.sponsor}/></Col>
                        </Row>
                        <Row gutter={40} style={{marginTop:"16px"}}>
                            <Col span={8}><TextInfo title={"活动联系人"} desc={this.props.data.contacts}/></Col>
                            <Col span={8}><TextInfo title={"联系方式"} desc={this.props.data.contactsWay}/></Col>
                            <Col span={8}><TextInfo title={"我的角色"} desc={this.showRoles(this.props.data.interviewJointers)}/></Col>
                        </Row>
                        <Row style={{marginTop:"16px"}}>
                            <Col span={24}><TextInfo title={"任务内容"}
                                                     desc={this.props.data.content}/></Col>
                        </Row>
                        <Row style={{marginTop:"16px"}}>
                            {this.state.loadAttachmentFiles?<Col span={24}>
                                    <FileInfo title={"附件"} files={this.state.files}/>
                                </Col>:
                                <Col span={24} style={{textAlign: "center"}}>
                                    <Spin />
                                </Col>}
                        </Row>
                    </div>
                </Scrollbars>
            </div>
        );
    }
}

NewsActivityBaseInfo.defaultProps = {
    data: {
        title:"",
        eventItem:"",
        interviewDate:"",
        place:"",
        endDate:"",
        contacts:"",
        contactsWay:"",
        content:"",
        sponsor:"",
        interviewJointers:[]
    }
};

class TextInfo extends Component{
    render() {
        return <div style={{width:"100%"}}>
            <div style={{fontSize: "14px",color: "#6c748b", marginBottom:"16px"}}><b>{this.props.title}</b></div>
            <div style={{fontSize: "14px",color: "#808eb5"}}>{this.props.desc}</div>
        </div>
    }
}

class FileInfo extends Component{
    render() {
        if(!this.props.files || this.props.files.length === 0 ){
            return <div></div>
        }
        return <div style={{width:"100%"}}>
            <div style={{fontSize: "14px",color: "#6c748b", }}><b>{this.props.title}</b></div>
                <UploadWall
                    accept={"."+[...PIC_TYPE, ...ATTCHMENT_TYPE].join(",.")}
                    multiple={true}
                    action="/cm-sites-pms/index/uploadFile"
                    listType="picture-card"
                    fileList={(()=>{
                        let fileList = [];
                        this.props.files && this.props.files.map(attachment=>{
                            fileList.push({
                                uid: uuid(),
                                ...attachment,
                                status: 'done',
                                path : attachment.url,
                                ext: getSubffix(attachment.name),
                            })
                        });
                        return fileList;
                    })()}
                    customRequest={new ChunkUpload({
                        checkFileURL:"/cm-sites-"+applicationName()+"/index/checkFile",
                        checkChunkURL:"/cm-sites-"+applicationName()+"/index/checkChunk",
                        uploadChunkURL:"/cm-sites-"+applicationName()+"/index/uploadChunks",
                        chunkUploadOverURL:"/cm-sites-"+applicationName()+"/index/chunkUploadOver",
                        mergeChunksURL:"/cm-sites-"+applicationName()+"/index/mergeChunks"
                    }).start}
                    icons={(()=>{
                        let res = ["download"];
                        return res;
                    })()}
                    uploadBtnName={""}
                    showUploadBtn={ false}
                    onDownload={(file)=>{
                        if(file.path.indexOf("?") === -1){
                            window.location.href = file.path + "?download=1";
                        }else{
                            window.location.href = file.path + "&download=1";
                        }
                    }}
                    style={{padding:"0px"}}
                />
                {/*<div style={{fontSize: "14px",color: "#808eb5"}}>*/}
                {/*{*/}
                {/*    this.props.files.map((item, index)=>{*/}
                {/*        return (*/}
                {/*            <div key={index} style={{marginTop:16,float:'left'}}>*/}
                {/*                <File name={item.name} path={"images/folder.png"} url={item.url}*/}
                {/*                                   style={{float: "left", marginLeft:(index+1)%6===1?0:20}}/>*/}
                {/*            </div>*/}
                {/*        )*/}

                {/*    })*/}
                {/*}*/}
                {/*<div style={{clear:'both'}}/>*/}
                {/*</div>*/}
        </div>
    }
}
class File extends Component{

    state = {
        shade: false
    };

    formatName = (name)=>{
        let maxLength = 16;
        if(name.length >= maxLength){
            return name.substring(0, maxLength - 1) + "...";
        }
        return name;
    };

    render() {
        return <div onMouseOver={(e)=>{this.setState({shade:true})}} onMouseOut={(e)=>this.setState({shade: false})} className={this.props.className} style={{width:"120px", height:"120px", backgroundColor: "#f4f6fc", borderRadius: "6px", position:"relative", ...this.props.style}}>
            {/*<img src={this.props.path} style={{position:"absolute", top:"32px", left:"44px"}} width={32} height={36}/>*/}
            <Icon type="file" style={{position:"absolute", top:"32px", left:"44px", fontSize:"32px"}} />
            <div style={{margin:"auto", marginTop:"78px", textAlign:"center"}}>{this.formatName(this.props.name)}</div>
            <div style={{width:"100%", height:"100%",textAlign:"center", backgroundColor:"#000000a6",position:"absolute",top:"0px",display:this.state.shade?"block":"none"}}>
                <Icon type={"download"} onClick={()=>{
                    if(this.props.url.indexOf("?") === -1){
                        window.location.href = this.props.url + "?download=1";
                    }else{
                        window.location.href = this.props.url + "&download=1";
                    }
                }} style={{marginTop:"44px",color:"#fff",fontSize:20}}/>
            </div>
        </div>
    }
}
File.defaultProps={
    style:{},
    className: ""
};

function mapStateToProps(state){
    return {
        currentUser: state.systemReducer.currentUser,
    }
}

export default connect(mapStateToProps)(NewsActivityBaseInfo);